import { SvgSprite } from './modules/svg-loader';
import { Modal } from './modules/a11y-modal';
import { RevealPanel } from './modules/revealPanel';
import { Accordion } from './modules/accordion';
import { Tabs } from './modules/tabs';
import { mainNavigation } from './modules/mainNavigation';
import { GoogleTranslate } from './modules/google-translate'
import * as YouTubeIframeLoader from 'youtube-iframe';
import './modules/sticky-sidebar-component';
import { Gallery } from './modules/gallery';
import { QuickDonate } from './modules/quickDonate';
import { HeaderVideo } from './modules/headerVideo';
import { VideoItem } from './modules/videoItem';
import { throttle, debounce } from 'lodash';
import { BioBlock } from './blocks/bio';
import { Alert } from './modules/alert';
import { VerisoulHelper } from './global/components/verisoul';
import { vhUnitInitial, vhUnitUpdate } from './helpers/vhUnitFix';
import { AnchorNav } from './modules/anchorNav';
import { truncateText } from './modules/truncate';
import { DisableFormButton } from './modules/disableFormButton';
import { DisableLink } from './modules/disableLink';

new SvgSprite('/Static/img/adage-sprite.svg');

new GoogleTranslate();

const navigationInit = () => {
    if (mainNavigation) mainNavigation.init();

    document.addEventListener('scroll', throttle(() => {
        if (mainNavigation) mainNavigation.scrollHandler();
    }, 10));
    window.addEventListener('resize', debounce(() => {
        if (mainNavigation) mainNavigation.resizeHandler();
    }, 50));
}


const verisoulHelperInit = () => {
    new VerisoulHelper();
}

const initializeGenericComponents = () => {
    //vh unit fix
    vhUnitInitial();
    vhUnitUpdate();
    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        vhUnitUpdate();
    });
    
    //Modals
    const modals = Array.prototype.slice.call(document.querySelectorAll('[data-modal]')) as HTMLElement[];
    modals.forEach(modal => {
        new Modal(modal);
    });

    const alerts = Array.prototype.slice.call(document.querySelectorAll('[data-alert]')) as HTMLElement[];
    alerts.forEach(alert => {
        new Alert(alert);
    });
    //Needs to be after the alert inits as it updates css variables for nav height
    navigationInit();

    if (Array.from(document.querySelectorAll('[data-bios]')).length > 0) {
        Array.from(document.querySelectorAll('[data-bios]')).forEach(bioBlock => {
            const showAllShowLessTriggers = (Array.from(bioBlock.querySelectorAll('[data-show-more]')) as HTMLButtonElement[]);
            new BioBlock(showAllShowLessTriggers);
        });
    }

    const panels = [].slice.call(document.querySelectorAll('[data-panel]')) as HTMLElement[];
    panels.forEach(panel => {
        new RevealPanel(panel);
    });

    const accordions = [].slice.call(document.querySelectorAll('[data-accordion-list]')) as HTMLElement[];
    accordions.forEach(accordionEl => {
        const oneOpenAtATime = accordionEl.getAttribute('data-one-open-at-a-time') == "true";
        new Accordion({ container: accordionEl, oneOpenAtATime: oneOpenAtATime });
    });

    const tabEls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabEls.forEach(tabEl => {
        new Tabs({ container: tabEl });
    })

    // Gallery Init
    document.addEventListener('DOMContentLoaded', function () {
        const galleryClass = 'gallery';
        const galleries = Array.prototype.slice.call(document.querySelectorAll('[data-gallery]'));
        galleries.forEach((gallery, index) => {
            gallery.classList.add(`${galleryClass}-${index}`);
            new Gallery(gallery);
        });
    });

    const quickDonateBlocks = [].slice.call(document.querySelectorAll('[data-quick-donate]'));
    quickDonateBlocks.forEach(block => {
        new QuickDonate(block);
    });

    // Header videos
    const headerVideoContainers = Array.prototype.slice.call(document.querySelectorAll('[data-header-video-container]')) as HTMLElement[];
    headerVideoContainers.forEach(HeaderVideoContainer => {
        new HeaderVideo(HeaderVideoContainer);
    });

    // Videos
    const videoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item]:not([data-video-type=youtube])')) as HTMLElement[];
    const youtubeVideoItems = Array.prototype.slice.call(document.querySelectorAll('[data-video-item][data-video-type=youtube]')) as HTMLElement[]
    videoItems.forEach(videoItem => {
        new VideoItem(videoItem);
    });
    YouTubeIframeLoader.load(YT => {
        youtubeVideoItems.forEach(youtubeVideoItem => {
            const iframe = youtubeVideoItem.querySelector('[data-youtube-id]');
            const ytvideoPlayer = new YT.Player(iframe.getAttribute('id'), {
                height: '390',
                width: '640',
                videoId: iframe.getAttribute('data-youtube-id'),
                events: {
                    onReady: () => {
                        new VideoItem(youtubeVideoItem, ytvideoPlayer);
                    }
                }
            });

        });

    });
    verisoulHelperInit();

    //Anchor Nav
    const anchorNav = document.querySelector('[data-anchor-nav]') as HTMLElement;
    if (anchorNav) {
        new AnchorNav(anchorNav);
    }

    //Truncate text helper example usage
    const truncateElements = Array.from(document.querySelectorAll('[data-truncate]')) as HTMLElement[];
    truncateElements.forEach(el => {
        truncateText(el);
    });

    const formsToDisableTheButton = Array.from(document.querySelectorAll('[data-disable-button]'));
    formsToDisableTheButton.forEach(form => {
        new DisableFormButton(form as HTMLFormElement);
    });

    const linksToDisableAfterClick = Array.from(document.querySelectorAll('[data-disable-link-after-click]'));
    linksToDisableAfterClick.forEach(linkToDisable => {
        new DisableLink(linkToDisable as HTMLLinkElement);
    });
}
initializeGenericComponents();